import dynamic from 'next/dynamic'

export const DynamicTradeInProductDeviceSkeleton = dynamic(() =>
	import('./TradeInProductDeviceSkeleton').then(({ TradeInProductDeviceSkeleton }) => TradeInProductDeviceSkeleton)
)
